import React, { useEffect } from "react";
import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import "./AboutMe.css";

const AboutMe = (props) => {
  useEffect(() => {
    const subscription = ScrollService.currentScreenFadeIn.subscribe(
      (screen) => {
        if (screen.fadeInScreen !== props.id) return;
        Animations.animations.fadeInScreen(props.id);
      }
    );
    return () => subscription.unsubscribe();
  }, [props.id]);

  return (
    <div className="about-me-container screen-container fade-in" id={props.id || ""}>
      <ScreenHeading title={"À Propos"} subHeading={"En quelques mots"} />
      <div className="about-me-content">
        <p className="about-me-description">
          <strong>Méticuleux</strong> et <strong>passionné</strong>, je suis Souleimane Zeggai,
          un <strong>Développeur Full-Stack</strong>. J'ai acquis des compétences transversales
          me permettant de concevoir des <strong>applications web modernes</strong>. Mon expérience
          m'a appris l'importance d'un <strong>code propre et performant</strong>, tout en restant
          à l'écoute des <strong>besoins utilisateurs</strong>. Je m'efforce de livrer
          des <strong>solutions robustes et évolutives</strong> pour répondre aux défis techniques
          les plus complexes.
        </p>
      </div>
    </div>
  );
};

export default AboutMe;
